import { cn } from "@/lib/utils";

export const EmptyState = ({
  title,
  description,
  icon: Icon,
  action,
  compact = false,
  testId = "empty-state",
  className,
}) => (
  <div
    className={cn(
      "border border-dashed border-dark-border bg-dark-surface-1 text-center min-w-0 rounded-md",
      compact ? "p-8 rounded-md" : "p-12 sm:p-16",
      className
    )}
    data-testid={testId}
  >
    {Icon ? (
      <div className="icon-frame w-12 h-12 mx-auto mb-4 border-brand-primary/40 flex">
        <Icon className="w-6 h-6 text-brand-primary" strokeWidth={1.5} aria-hidden="true" />
      </div>
    ) : null}
    {title ? (
      <h3 className={cn("font-heading tracking-wider uppercase text-dark-text-primary", compact ? "text-xl" : "text-2xl sm:text-3xl")}>
        {title}
      </h3>
    ) : null}
    {description ? (
      <p className="text-sm text-dark-text-secondary mt-3 max-w-md mx-auto leading-relaxed">{description}</p>
    ) : null}
    {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
  </div>
);
